import WarningModal from 'src/components/WarningModal'
import { capitalizeWords } from '@sportninja/common/ts-utils'
type Props = {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}

/**
 * Unsaved-changes guard for the Edit Player form. Mirrors the competition
 * wizard's ConfirmCloseModal — shown when the user tries to Cancel/Back with a
 * dirty form.
 */
const ConfirmDiscardChangesModal = ({ open, onCancel, onConfirm }: Props) => {
  return (
    <WarningModal
      isOpen={open}
      onClose={onCancel}
      onConfirm={onConfirm}
      title={capitalizeWords('Warning! Before You Proceed')}
      description={
        <>
          You have unsaved changes.
          <br />
          Closing this form will discard them.
        </>
      }
      cancelLabel='KEEP EDITING'
      confirmLabel='DISCARD'
      destructive
    />
  )
}

export default ConfirmDiscardChangesModal
